/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetTimesheetCustomersQueryResponse,
  GetTimesheetCustomersQueryParams,
} from '../models/GetTimesheetCustomers.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getTimesheetCustomersQueryResponseSchema } from '../zod/getTimesheetCustomersSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getTimesheetCustomersQueryKey = (
  params?: GetTimesheetCustomersQueryParams,
) => [{ url: '/api/entries/customers' }, ...(params ? [params] : [])] as const;

export type GetTimesheetCustomersQueryKey = ReturnType<
  typeof getTimesheetCustomersQueryKey
>;

/**
 * {@link /api/entries/customers}
 */
export async function getTimesheetCustomers(
  params?: GetTimesheetCustomersQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTimesheetCustomersQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/entries/customers`,
    params,
    ...requestConfig,
  });
  return getTimesheetCustomersQueryResponseSchema.parse(res.data);
}

export function getTimesheetCustomersQueryOptions(
  params?: GetTimesheetCustomersQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getTimesheetCustomersQueryKey(params);
  return queryOptions<
    GetTimesheetCustomersQueryResponse,
    ResponseErrorConfig<Error>,
    GetTimesheetCustomersQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getTimesheetCustomers(params, config);
    },
  });
}

/**
 * {@link /api/entries/customers}
 */
export function useGetTimesheetCustomers<
  TData = GetTimesheetCustomersQueryResponse,
  TQueryData = GetTimesheetCustomersQueryResponse,
  TQueryKey extends QueryKey = GetTimesheetCustomersQueryKey,
>(
  params?: GetTimesheetCustomersQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTimesheetCustomersQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getTimesheetCustomersQueryKey(params);

  const query = useQuery(
    {
      ...getTimesheetCustomersQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
